import {
  EXPIRE_AFTER_ALLOWED_UNITS,
  EXPIRE_AFTER_MIN_HOUR_QUANTITY,
  JOURNEY_SYNC_EXPIRY_WORKSPACE_DEFAULT,
} from "@hightouch/lib/journeys/types/config-types";

import { TIME_OPTIONS } from "src/constants";
import { IntervalUnit } from "src/types/visual";

export type ExpireAfter = { unit: IntervalUnit; quantity: number };

export const EXPIRE_AFTER_TIME_OPTIONS = TIME_OPTIONS.filter((option) =>
  EXPIRE_AFTER_ALLOWED_UNITS.some((unit) => unit === option.value),
);

export const DEFAULT_EXPIRE_AFTER: ExpireAfter = {
  unit: IntervalUnit.Day,
  quantity: 1,
};

export const DEFAULT_WAIT_FOR: ExpireAfter = {
  unit: IntervalUnit.Day,
  quantity: 3,
};

export const WORKSPACE_EXPIRY_DEFAULT: ExpireAfter =
  JOURNEY_SYNC_EXPIRY_WORKSPACE_DEFAULT;

// Only Hour can dip below a day; the rest clear the floor at 1.
export const minQuantityForUnit = (unit: IntervalUnit | undefined) =>
  unit === IntervalUnit.Hour ? EXPIRE_AFTER_MIN_HOUR_QUANTITY : 1;

export const formatExpireAfter = (value: ExpireAfter | null | undefined) => {
  if (!value?.unit || value.quantity == null) {
    return "no expiry";
  }
  return `${value.quantity} ${value.unit}${value.quantity === 1 ? "" : "s"}`;
};
